import { useEffect } from "react";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import { useNavigate } from "react-router-dom";
import { useLocale } from "@/lib/locale";

export default function FallbackChat() {
    const nav = useNavigate();
    const { t } = useLocale();
    useEffect(() => {
        (async () => {
            const { data } = await api.post("/conversations", { presence_id: null });
            nav(`/chat/${data.conversation_id}`, { replace: true, state: { presence: null } });
        })();
    }, []); // eslint-disable-line

    return (
        <div className="grain min-h-screen candle-halo">
            <Header />
            <p className="max-w-3xl mx-auto px-6 pt-20 text-ink-textLow font-serif italic">{t("fallback.loading")}</p>
        </div>
    );
}
